<script>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

export default {
	setup() {
		const { t, tm } = useI18n();
		const bios = computed(() => tm('about.bios'));
		const socialSharingsHeading = computed(() => t('about.socialSharingsHeading'));
		return {
			bios,
			socialSharingsHeading,
			socialSharings: [
				{
					id: 1,
					name: 'Twitter',
					icon: 'twitter',
					url: 'https://twitter.com/iqbalarauf',
				},
				{
					id: 2,
					name: 'Instagram',
					icon: 'instagram',
					url: 'https://instagram.com/iqbalarauf',
				},
				{
					id: 3,
					name: 'LinkedIn',
					icon: 'linkedin',
					url: 'https://linkedin.com/in/iqbalarauf',
				},
				{
					id: 4,
					name: 'Github',
					icon: 'github',
					url: 'https://github.com/iqbalarauf',
				},
				{
					id: 5,
					name: 'Gitlab',
					icon: 'gitlab',
					url: 'https://gitlab.com/iqbalarauf',
				},
			],
		};
	},
};
</script>

<template>
  <div class="block sm:flex sm:gap-5 mt-10 sm:mt-20">
    <!-- About profile image -->
    <div class="w-full sm:w-1/4 mb-7 sm:mb-0 sm:items-center">
      <img
        :src="require('@/assets/images/casualprofile.png')"
        class="rounded-xl w-96"
        alt=""
      >
      <p
        class="text-left font-general-medium text-2xl text-ternary-dark dark:text-ternary-light mb-2 mt-5"
      >
        {{ socialSharingsHeading }}
      </p>
      <div class="flex items-center gap-5 mt-5">
        <a
          v-for="social in socialSharings"
          :key="social.id"
          :href="social.url"
          target="__blank"
          aria-label="Share Project"
          class="bg-ternary-light dark:bg-ternary-dark text-gray-400 hover:text-primary-dark dark:hover:text-primary-light p-2 rounded-lg shadow-sm duration-500"
        ><i
          :data-feather="social.icon"
          class="w-4 lg:w-5 h-4 lg:h-5"
        /></a>
      </div>
    </div>

    <!-- About details -->
    <div class="w-full sm:w-3/4 text-justify align-center">
      <div
        v-for="bio in bios"
        :key="bio.id"
      >
        <!-- Single paragraph bio -->
        <p
          v-if="bio.bio"
          class="font-general-regular mb-4 text-ternary-dark dark:text-ternary-light text-lg"
        >
          {{ bio.bio }}
        </p>

        <!-- Points list bio -->
        <div v-if="bio.points" class="mb-4">
          <p
            v-for="(point, index) in bio.points"
            :key="index"
            class="font-general-regular text-ternary-dark dark:text-ternary-light text-lg"
          >
            - {{ point }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
